import { useState, useEffect } from 'react';
import { api } from '../api';

const NIVEL_STYLE = {
  critico: { bg: '#3a1a1a', color: '#e63946', border: '#e63946', label: '🔴 Crítico' },
  urgente: { bg: '#3a2a1a', color: '#ff9800', border: '#ff9800', label: '🟠 Urgente' },
  bajo:    { bg: '#2a2a1a', color: '#ffc107', border: '#ffc107', label: '🟡 Bajo' },
};

export default function Reposicion() {
  const [datos, setDatos] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [tab, setTab] = useState('alertas');
  const [busqueda, setBusqueda] = useState('');
  const [buscandoMuerto, setBuscandoMuerto] = useState(false);
  // Modal detalle
  const [productoDetalle, setProductoDetalle] = useState(null);
  const [cargandoDetalle, setCargandoDetalle] = useState(false);
  const [modalAbierto, setModalAbierto] = useState(false);
  // Reposición manual
  const [marcas, setMarcas] = useState([]);
  const [marcaManual, setMarcaManual] = useState('');
  const [busquedaMarca, setBusquedaMarca] = useState('');
  const [productosManual, setProductosManual] = useState([]);
  const [cargandoManual, setCargandoManual] = useState(false);
  const [guardandoOrden, setGuardandoOrden] = useState(false);
  const [ordenGuardada, setOrdenGuardada] = useState(null);
  const [historialOrdenes, setHistorialOrdenes] = useState([]);
  const [cargandoHistorial, setCargandoHistorial] = useState(false);
  const [detalleOrden, setDetalleOrden] = useState(null);
  const [cargandoDetalleOrden, setCargandoDetalleOrden] = useState(false);

  useEffect(() => { cargar(); cargarMarcas(); }, []);

  const cargar = async (q = '') => {
    setCargando(true);
    try {
      const url = q ? `/reposicion?q=${encodeURIComponent(q)}` : '/reposicion';
      const data = await api.get(url);
      setDatos(data.error ? null : data);
    } catch (e) { console.error(e); }
    finally { setCargando(false); setBuscandoMuerto(false); }
  };

  const cargarMarcas = async () => {
    try {
      const data = await api.get('/inventario/marcas');
      setMarcas(data.marcas || []);
    } catch (e) { console.error(e); }
  };

  const buscarMuerto = () => { setBuscandoMuerto(true); cargar(busqueda); };
  const limpiarBusqueda = () => { setBusqueda(''); cargar(''); };

  const abrirDetalle = async (codigo) => {
    setModalAbierto(true);
    setCargandoDetalle(true);
    setProductoDetalle(null);
    try {
      const data = await api.get(`/inventario/producto/${codigo}`);
      setProductoDetalle(data);
    } catch (e) { console.error(e); }
    finally { setCargandoDetalle(false); }
  };

  const cerrarModal = () => { setModalAbierto(false); setProductoDetalle(null); };

  const cargarProductosMarca = async (marca) => {
    setMarcaManual(marca);
    setProductosManual([]);
    setOrdenGuardada(null);
    setCargandoManual(true);
    try {
      const data = await api.get(`/reposicion/manual?marca=${encodeURIComponent(marca)}`);
      setProductosManual((data.productos || []).map(p => ({ ...p, cantidad_pedir: '' })));
    } catch (e) { console.error(e); }
    finally { setCargandoManual(false); }
  };

  const actualizarCantidad = (idx, valor) => {
    setProductosManual(productosManual.map((p, i) => i === idx ? { ...p, cantidad_pedir: valor } : p));
  };

  const itemsConCantidad = productosManual.filter(p => p.cantidad_pedir !== '' && parseFloat(p.cantidad_pedir) > 0);

  const totalOrden = itemsConCantidad.reduce((a, p) => a + parseFloat(p.cantidad_pedir) * p.costo, 0);

  const guardarOrden = async () => {
    if (itemsConCantidad.length === 0) { alert('Ingresa al menos una cantidad'); return; }
    setGuardandoOrden(true);
    try {
      const items = itemsConCantidad.map(p => ({
        codigo: p.codigo,
        descripcion: p.item,
        cantidad_pedir: parseFloat(p.cantidad_pedir),
        costo_unitario: p.costo,
        valor_total: parseFloat(p.cantidad_pedir) * p.costo
      }));
      const data = await api.post('/reposicion/orden', { marca: marcaManual, items, creado_por: 'admin' });
      setOrdenGuardada(data.orden_id);
    } catch (e) { alert('Error guardando orden'); }
    finally { setGuardandoOrden(false); }
  };

  const cargarHistorialOrdenes = async () => {
    setCargandoHistorial(true);
    try {
      const data = await api.get('/reposicion/ordenes');
      setHistorialOrdenes(data.ordenes || []);
    } catch (e) { console.error(e); }
    finally { setCargandoHistorial(false); }
  };

  const verDetalleOrden = async (id) => {
    setCargandoDetalleOrden(true);
    setDetalleOrden(null);
    try {
      const data = await api.get(`/reposicion/orden/${id}`);
      setDetalleOrden(data);
    } catch (e) { console.error(e); }
    finally { setCargandoDetalleOrden(false); }
  };

  const imprimirOrdenHistorial = (orden, items) => {
    const html = `
    <html><head><meta charset="UTF-8">
    <style>
      * { box-sizing:border-box; margin:0; padding:0; }
      body { font-family:Arial,sans-serif; padding:20px; font-size:12px; }
      .header { display:flex; justify-content:space-between; margin-bottom:20px; }
      h1 { font-size:18px; color:#1a1a2e; }
      .sub { color:#888; font-size:11px; margin-top:4px; }
      table { width:100%; border-collapse:collapse; margin-top:16px; }
      th { background:#1a1a2e; color:#fff; padding:8px 10px; font-size:11px; text-align:left; }
      td { padding:8px 10px; border-bottom:1px solid #eee; font-size:12px; }
      .firma { margin-top:40px; display:flex; justify-content:space-between; }
      .firma-line { border-top:1px solid #000; width:45%; padding-top:4px; font-size:10px; color:#888; text-align:center; }
    </style></head>
    <body>
      <div class="header">
        <div>
          <h1>🔧 TALLER ZOLER — Orden a Proveedor</h1>
          <div class="sub">Fecha: ${orden.fecha} · Marca: ${orden.marca} · ${items.length} productos</div>
        </div>
        <div style="text-align:right">
          <div style="font-size:20px;font-weight:bold;color:#1a1a2e;">ORDEN #${orden.id}</div>
          <div style="font-size:10px;color:#888;">LEON FONFAY LUBRICANTES</div>
        </div>
      </div>
      <table>
        <tr>
          <th style="width:100px">Código</th>
          <th>Descripción</th>
          <th style="width:100px;text-align:center">Cantidad</th>
        </tr>
        ${items.map(i => `
          <tr>
            <td style="color:#555;font-size:11px">${i.codigo}</td>
            <td>${i.descripcion}</td>
            <td style="text-align:center;font-weight:bold;font-size:14px">${i.cantidad_pedir.toFixed(0)}</td>
          </tr>`).join('')}
      </table>
      <div class="firma">
        <div class="firma-line">AUTORIZADO POR</div>
        <div class="firma-line">RECIBIDO POR</div>
      </div>
    </body></html>`;
    const ventana = window.open('', '_blank', 'width=900,height=700');
    ventana.document.write(html);
    ventana.document.close();
    ventana.onload = () => { ventana.focus(); ventana.print(); };
  };

  const imprimirOrden = () => {
    if (itemsConCantidad.length === 0) { alert('Ingresa al menos una cantidad'); return; }
    const fecha = new Date().toLocaleDateString('es-EC');
    const html = `
    <html><head><meta charset="UTF-8">
    <style>
      * { box-sizing:border-box; margin:0; padding:0; }
      body { font-family:Arial,sans-serif; padding:20px; font-size:12px; }
      .header { display:flex; justify-content:space-between; margin-bottom:20px; }
      h1 { font-size:18px; color:#1a1a2e; }
      .sub { color:#888; font-size:11px; margin-top:4px; }
      table { width:100%; border-collapse:collapse; margin-top:16px; }
      th { background:#1a1a2e; color:#fff; padding:8px 10px; font-size:11px; text-align:left; }
      td { padding:8px 10px; border-bottom:1px solid #eee; font-size:12px; }
      .total { text-align:right; margin-top:16px; font-size:14px; font-weight:bold; color:#1a1a2e; }
      .firma { margin-top:40px; display:flex; justify-content:space-between; }
      .firma-line { border-top:1px solid #000; width:45%; padding-top:4px; font-size:10px; color:#888; text-align:center; }
    </style></head>
    <body>
      <div class="header">
        <div>
          <h1>🔧 TALLER ZOLER — Orden a Proveedor</h1>
          <div class="sub">Fecha: ${fecha} · Marca: ${marcaManual} · ${itemsConCantidad.length} productos</div>
        </div>
        <div style="text-align:right">
          <div style="font-size:20px;font-weight:bold;color:#1a1a2e;">ORDEN #${ordenGuardada || 'BORRADOR'}</div>
          <div style="font-size:10px;color:#888;">LEON FONFAY LUBRICANTES</div>
        </div>
      </div>
      <table>
        <tr>
          <th style="width:100px">Código</th>
          <th>Descripción</th>
          <th style="width:100px;text-align:center">Cantidad</th>
        </tr>
        ${itemsConCantidad.map(p => `
          <tr>
            <td style="color:#555;font-size:11px">${p.codigo}</td>
            <td>${p.item}</td>
            <td style="text-align:center;font-weight:bold;font-size:14px">${parseFloat(p.cantidad_pedir).toFixed(0)}</td>
          </tr>`).join('')}
      </table>
      <div class="firma">
        <div class="firma-line">AUTORIZADO POR</div>
        <div class="firma-line">RECIBIDO POR</div>
      </div>
    </body></html>`;
    const ventana = window.open('', '_blank', 'width=900,height=700');
    ventana.document.write(html);
    ventana.document.close();
    ventana.onload = () => { ventana.focus(); ventana.print(); };
  };

  const marcasFiltradas = marcas.filter(m => m.toLowerCase().includes(busquedaMarca.toLowerCase()));

  if (cargando && tab !== 'manual') return <p style={s.cargando}>Analizando inventario...</p>;

  return (
    <div style={{ position: 'relative' }}>
      {/* Header */}
      <div style={s.headerRow}>
        <div>
          <h2 style={s.titulo}>🧠 Reposición Inteligente</h2>
          <p style={s.subtitulo}>Basado en promedio de ventas de los últimos 90 días</p>
        </div>
        <button style={s.botonRefresh} onClick={() => cargar('')}>🔄 Actualizar</button>
      </div>

      {/* KPIs */}
      {datos && (
        <div style={s.kpisRow}>
          <div style={{...s.kpiCard, borderTopColor: '#e63946', cursor: 'pointer'}} onClick={() => setTab('alertas')}>
            <div style={{...s.kpiValor, color: '#e63946'}}>{datos.total_critico}</div>
            <div style={s.kpiLabel}>🔴 Críticos</div>
          </div>
          <div style={{...s.kpiCard, borderTopColor: '#ff9800', cursor: 'pointer'}} onClick={() => setTab('alertas')}>
            <div style={{...s.kpiValor, color: '#ff9800'}}>{datos.total_urgente}</div>
            <div style={s.kpiLabel}>🟠 Urgentes</div>
          </div>
          <div style={{...s.kpiCard, borderTopColor: '#ffc107', cursor: 'pointer'}} onClick={() => setTab('alertas')}>
            <div style={{...s.kpiValor, color: '#ffc107'}}>{datos.total_bajo}</div>
            <div style={s.kpiLabel}>🟡 Stock bajo</div>
          </div>
          <div style={{...s.kpiCard, borderTopColor: '#9c27b0', cursor: 'pointer'}} onClick={() => setTab('muerto')}>
            <div style={{...s.kpiValor, color: '#9c27b0'}}>{datos.total_stock_muerto}</div>
            <div style={s.kpiLabel}>💀 Stock muerto</div>
          </div>
          <div style={{...s.kpiCard, borderTopColor: '#9c27b0', cursor: 'pointer'}} onClick={() => setTab('muerto')}>
            <div style={{...s.kpiValor, color: '#9c27b0', fontSize: 20}}>${datos.valor_stock_muerto.toLocaleString('es-EC', {minimumFractionDigits: 2})}</div>
            <div style={s.kpiLabel}>💰 Valor estancado</div>
          </div>
        </div>
      )}

      {/* Tabs */}
      <div style={s.tabs}>
        <button style={{...s.tab, ...(tab === 'alertas' ? s.tabActivo : {})}} onClick={() => setTab('alertas')}>
          🚨 Alertas
          {datos && datos.total_critico + datos.total_urgente + datos.total_bajo > 0 && (
            <span style={s.tabBadge}>{datos.total_critico + datos.total_urgente + datos.total_bajo}</span>
          )}
        </button>
        <button style={{...s.tab, ...(tab === 'muerto' ? {...s.tabActivo, borderBottomColor: '#9c27b0'} : {})}} onClick={() => setTab('muerto')}>
          💀 Stock Muerto
          {datos && <span style={{...s.tabBadge, background: '#9c27b0'}}>{datos.total_stock_muerto}</span>}
        </button>
        <button style={{...s.tab, ...(tab === 'manual' ? {...s.tabActivo, borderBottomColor: '#4cc9f0'} : {})}} onClick={() => setTab('manual')}>
          📋 Reposición Manual
        </button>
        <button style={{...s.tab, ...(tab === 'historial' ? {...s.tabActivo, borderBottomColor: '#4caf50'} : {})}}
          onClick={() => { setTab('historial'); cargarHistorialOrdenes(); }}>
          📦 Historial Órdenes
        </button>
      </div>

      {/* Contenido */}
      <div style={s.contenido}>

        {/* TAB ALERTAS */}
        {tab === 'alertas' && datos && (
          datos.alertas.length === 0 ? (
            <div style={s.sinAlertas}>
              <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
              <p style={{ color: '#4caf50', fontSize: 16, fontWeight: 'bold' }}>Todo el inventario está bien</p>
              <p style={{ color: '#555', fontSize: 13, marginTop: 8 }}>No hay productos que necesiten reposición en los próximos 15 días</p>
            </div>
          ) : (
            <>
              <div style={s.tabla}>
                <div style={s.tablaHeader}>
                  <span style={{ width: 90 }}>NIVEL</span>
                  <span style={{ flex: 4 }}>PRODUCTO</span>
                  <span style={{ flex: 1 }}>MARCA</span>
                  <span style={{ width: 80, textAlign: 'right' }}>STOCK</span>
                  <span style={{ width: 90, textAlign: 'right' }}>DÍAS</span>
                  <span style={{ width: 90, textAlign: 'right' }}>PEDIR</span>
                  <span style={{ width: 110, textAlign: 'right' }}>COSTO REP.</span>
                </div>
                {datos.alertas.map((a, i) => {
                  const nv = NIVEL_STYLE[a.nivel];
                  return (
                    <div key={i}
                      style={{...s.tablaRow, background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e', cursor: 'pointer'}}
                      onClick={() => abrirDetalle(a.codigo)}
                      onMouseEnter={e => e.currentTarget.style.background = '#2d2d44'}
                      onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#1e1e2e' : '#1a1a2e'}
                    >
                      <span style={{ width: 90 }}>
                        <span style={{ background: nv.bg, color: nv.color, border: `1px solid ${nv.border}`, borderRadius: 6, padding: '3px 6px', fontSize: 10, fontWeight: 'bold' }}>{nv.label}</span>
                      </span>
                      <span style={{ flex: 4 }}>
                        <div style={{ color: '#fff', fontSize: 13 }}>{a.item}</div>
                        <div style={{ color: '#555', fontSize: 11 }}>{a.codigo_bar} · {a.promedio_diario} uds/día</div>
                      </span>
                      <span style={{ flex: 1, color: '#aaa', fontSize: 12 }}>{a.marca}</span>
                      <span style={{ width: 80, textAlign: 'right', color: a.stock_actual <= 0 ? '#e63946' : '#fff', fontWeight: 'bold' }}>{a.stock_actual.toFixed(0)}</span>
                      <span style={{ width: 90, textAlign: 'right', color: a.dias_restantes <= 3 ? '#e63946' : a.dias_restantes <= 7 ? '#ff9800' : '#ffc107', fontWeight: 'bold' }}>
                        {a.dias_restantes === 999 ? '∞' : `${a.dias_restantes}d`}
                      </span>
                      <span style={{ width: 90, textAlign: 'right', color: '#4cc9f0', fontWeight: 'bold' }}>{a.cantidad_sugerida}</span>
                      <span style={{ width: 110, textAlign: 'right', color: '#aaa', fontSize: 13 }}>${a.costo_reposicion.toFixed(2)}</span>
                    </div>
                  );
                })}
              </div>
              <div style={s.totalRow}>
                <span style={{ color: '#aaa', fontSize: 13 }}>Costo total estimado:</span>
                <span style={{ color: '#4cc9f0', fontWeight: 'bold', fontSize: 16, marginLeft: 12 }}>
                  ${datos.alertas.reduce((a, p) => a + p.costo_reposicion, 0).toFixed(2)}
                </span>
              </div>
            </>
          )
        )}

        {/* TAB STOCK MUERTO */}
        {tab === 'muerto' && datos && (
          <>
            <div style={s.muertoInfo}>
              <span style={{ color: '#aaa', fontSize: 13 }}>
                {datos.busqueda
                  ? `Resultados para "${datos.busqueda}" — ${datos.stock_muerto.length} productos`
                  : `Top 50 por valor estancado de ${datos.total_stock_muerto} productos sin movimiento en 180 días`}
              </span>
            </div>
            <div style={s.buscadorRow}>
              <input style={s.inputBusqueda} value={busqueda} onChange={e => setBusqueda(e.target.value)}
                placeholder="Buscar por descripción o marca..." onKeyDown={e => e.key === 'Enter' && buscarMuerto()} />
              <button style={s.botonBuscar} onClick={buscarMuerto} disabled={buscandoMuerto}>
                {buscandoMuerto ? '...' : '🔍 Buscar'}
              </button>
              {datos.busqueda && <button style={s.botonLimpiar} onClick={limpiarBusqueda}>✕ Limpiar</button>}
            </div>
            <div style={s.tabla}>
              <div style={s.tablaHeader}>
                <span style={{ flex: 1 }}>CÓDIGO</span>
                <span style={{ flex: 4 }}>DESCRIPCIÓN</span>
                <span style={{ flex: 1 }}>MARCA</span>
                <span style={{ width: 90, textAlign: 'right' }}>STOCK</span>
                <span style={{ width: 90, textAlign: 'right' }}>COSTO</span>
                <span style={{ width: 110, textAlign: 'right' }}>VALOR EST.</span>
              </div>
              {datos.stock_muerto.map((p, i) => (
                <div key={i}
                  style={{...s.tablaRow, background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e', cursor: 'pointer'}}
                  onClick={() => abrirDetalle(p.codigo)}
                  onMouseEnter={e => e.currentTarget.style.background = '#2d2d44'}
                  onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#1e1e2e' : '#1a1a2e'}
                >
                  <span style={{ flex: 1, color: '#555', fontSize: 11 }}>{p.codigo_bar || p.codigo}</span>
                  <span style={{ flex: 4, color: '#fff', fontSize: 13 }}>{p.item}</span>
                  <span style={{ flex: 1, color: '#aaa', fontSize: 12 }}>{p.marca}</span>
                  <span style={{ width: 90, textAlign: 'right', color: '#fff', fontWeight: 'bold' }}>{p.stock_actual.toFixed(0)}</span>
                  <span style={{ width: 90, textAlign: 'right', color: '#aaa', fontSize: 13 }}>${p.costo_unitario.toFixed(2)}</span>
                  <span style={{ width: 110, textAlign: 'right', color: '#9c27b0', fontWeight: 'bold' }}>${p.valor_estancado.toFixed(2)}</span>
                </div>
              ))}
            </div>
          </>
        )}

        {/* TAB HISTORIAL ÓRDENES */}
{tab === 'historial' && (
  <>
    {cargandoHistorial ? (
      <p style={s.cargando}>Cargando historial...</p>
    ) : (
      <>
        {/* Modal detalle orden */}
        {detalleOrden && (
          <div style={s.modalOverlay} onClick={() => setDetalleOrden(null)}>
            <div style={s.modal} onClick={e => e.stopPropagation()}>
              <div style={s.modalHeader}>
                <span style={s.modalTitulo}>
                  Orden #{detalleOrden.orden.id} — {detalleOrden.orden.marca} — {detalleOrden.orden.fecha}
                </span>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button style={s.botonImprimir}
                    onClick={() => imprimirOrdenHistorial(detalleOrden.orden, detalleOrden.items)}>
                    🖨️ Imprimir
                  </button>
                  <button style={s.modalCerrar} onClick={() => setDetalleOrden(null)}>✕</button>
                </div>
              </div>
              <div style={{ padding: 28, overflowY: 'auto' }}>
                <div style={s.kpisRow}>
                  <div style={s.kpiCard}>
                    <div style={s.kpiValor}>{detalleOrden.orden.total_items}</div>
                    <div style={s.kpiLabel}>Productos</div>
                  </div>
                  <div style={{...s.kpiCard, borderTopColor: '#4cc9f0'}}>
                    <div style={{...s.kpiValor, fontSize: 20}}>${detalleOrden.orden.total_valor.toFixed(2)}</div>
                    <div style={s.kpiLabel}>Valor total</div>
                  </div>
                </div>
                <div style={s.tabla}>
                  <div style={s.tablaHeader}>
                    <span style={{ flex: 1 }}>CÓDIGO</span>
                    <span style={{ flex: 4 }}>DESCRIPCIÓN</span>
                    <span style={{ width: 90, textAlign: 'right' }}>CANTIDAD</span>
                    <span style={{ width: 90, textAlign: 'right' }}>COSTO</span>
                    <span style={{ width: 110, textAlign: 'right' }}>VALOR</span>
                  </div>
                  {detalleOrden.items.map((item, i) => (
                    <div key={i} style={{...s.tablaRow, background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e'}}>
                      <span style={{ flex: 1, color: '#555', fontSize: 11 }}>{item.codigo}</span>
                      <span style={{ flex: 4, color: '#fff', fontSize: 13 }}>{item.descripcion}</span>
                      <span style={{ width: 90, textAlign: 'right', color: '#4cc9f0', fontWeight: 'bold' }}>{item.cantidad_pedir.toFixed(0)}</span>
                      <span style={{ width: 90, textAlign: 'right', color: '#aaa' }}>${item.costo_unitario.toFixed(2)}</span>
                      <span style={{ width: 110, textAlign: 'right', color: '#fff' }}>${item.valor_total.toFixed(2)}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        <div style={s.tabla}>
          <div style={s.tablaHeader}>
            <span style={{ width: 60 }}>#</span>
            <span style={{ flex: 1 }}>Fecha</span>
            <span style={{ flex: 1 }}>Marca</span>
            <span style={{ width: 80, textAlign: 'center' }}>Items</span>
            <span style={{ width: 120, textAlign: 'right' }}>Valor total</span>
            <span style={{ width: 100, textAlign: 'center' }}>Acción</span>
          </div>
          {historialOrdenes.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#555' }}>No hay órdenes registradas</div>
          ) : historialOrdenes.map((o, i) => (
            <div key={o.id} style={{...s.tablaRow, background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e'}}>
              <span style={{ width: 60, color: '#4cc9f0', fontWeight: 'bold' }}>#{o.id}</span>
              <span style={{ flex: 1, color: '#fff', fontSize: 13 }}>{o.fecha}</span>
              <span style={{ flex: 1, color: '#aaa', fontSize: 13 }}>{o.marca}</span>
              <span style={{ width: 80, textAlign: 'center', color: '#fff' }}>{o.total_items}</span>
              <span style={{ width: 120, textAlign: 'right', color: '#4cc9f0', fontWeight: 'bold' }}>${o.total_valor.toFixed(2)}</span>
              <span style={{ width: 100, textAlign: 'center' }}>
                <button style={s.botonVer} onClick={() => verDetalleOrden(o.id)}>
                  {cargandoDetalleOrden ? '...' : 'Ver →'}
                </button>
              </span>
            </div>
          ))}
        </div>
      </>
    )}
  </>
)}

        {/* TAB REPOSICIÓN MANUAL */}
        {tab === 'manual' && (
          <div style={s.manualContainer}>
            {/* Sidebar marcas */}
            <div style={s.manualSidebar}>
              <div style={s.sidebarTitulo}>🏷️ Selecciona marca</div>
              <input style={s.searchMarca} value={busquedaMarca} onChange={e => setBusquedaMarca(e.target.value)} placeholder="Buscar marca..." />
              <div style={s.marcasList}>
                {marcasFiltradas.map(m => (
                  <div key={m}
                    style={{...s.marcaItem, ...(marcaManual === m ? s.marcaItemActivo : {})}}
                    onClick={() => cargarProductosMarca(m)}>
                    {m}
                  </div>
                ))}
              </div>
            </div>

            {/* Tabla productos */}
            <div style={s.manualMain}>
              {!marcaManual ? (
                <div style={s.sinAlertas}>
                  <div style={{ fontSize: 48, marginBottom: 16 }}>🏷️</div>
                  <p style={{ color: '#aaa', fontSize: 15 }}>Selecciona una marca para comenzar</p>
                </div>
              ) : cargandoManual ? (
                <p style={s.cargando}>Cargando productos de {marcaManual}...</p>
              ) : (
                <>
                  {/* Header con acciones */}
                  <div style={s.manualHeader}>
                    <div>
                      <span style={{ color: '#fff', fontWeight: 'bold', fontSize: 15 }}>🏷️ {marcaManual}</span>
                      <span style={{ color: '#555', fontSize: 13, marginLeft: 12 }}>{productosManual.length} productos</span>
                      {itemsConCantidad.length > 0 && (
                        <span style={{ color: '#4cc9f0', fontSize: 13, marginLeft: 12 }}>
                          · {itemsConCantidad.length} seleccionados · ${totalOrden.toFixed(2)}
                        </span>
                      )}
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button style={s.botonImprimir} onClick={imprimirOrden} disabled={itemsConCantidad.length === 0}>
                        🖨️ Imprimir orden
                      </button>
                      <button
                        style={{...s.botonGuardar, ...(ordenGuardada ? { background: '#2e7d32' } : {})}}
                        onClick={guardarOrden}
                        disabled={guardandoOrden || !!ordenGuardada || itemsConCantidad.length === 0}
                      >
                        {guardandoOrden ? 'Guardando...' : ordenGuardada ? `✅ Guardada #${ordenGuardada}` : '💾 Guardar orden'}
                      </button>
                    </div>
                  </div>

                  {/* Tabla */}
                  <div style={s.tabla}>
                    <div style={s.tablaHeader}>
                      <span style={{ flex: 1, fontSize: 10 }}>CÓDIGO</span>
                      <span style={{ flex: 4 }}>DESCRIPCIÓN</span>
                      <span style={{ width: 70, textAlign: 'right' }}>STOCK</span>
                      <span style={{ width: 80, textAlign: 'right' }}>PROM. 90d</span>
                      <span style={{ width: 100, textAlign: 'center' }}>A PEDIR</span>
                      <span style={{ width: 80, textAlign: 'right' }}>COSTO</span>
                      <span style={{ width: 110, textAlign: 'right' }}>VALOR REP.</span>
                    </div>
                    {productosManual.map((p, i) => {
                      const cant = parseFloat(p.cantidad_pedir) || 0;
                      const valorRep = cant * p.costo;
                      return (
                        <div key={i} style={{...s.tablaRow, background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e', ...(cant > 0 ? { borderLeft: '3px solid #4cc9f0' } : {})}}>
                          <span style={{ flex: 1,color: '#fff',  fontSize: 11 }}>{p.codigo_bar || p.codigo}</span>
                          <span style={{ flex: 4, color: '#fff', fontSize: 13 }}>{p.item}</span>
                          <span style={{ width: 70, textAlign: 'right', color: p.stock <= 0 ? '#e63946' : '#aaa' }}>{p.stock.toFixed(0)}</span>
                          <span style={{ width: 80, textAlign: 'right', color: '#4cc9f0', fontSize: 12 }}>{p.promedio_90.toFixed(0)}</span>
                          <div style={{ width: 100, display: 'flex', justifyContent: 'center' }}>
                            <input
                              style={{...s.inputCantidad, ...(cant > 0 ? { borderColor: '#4cc9f0' } : {})}}
                              type="number"
                              min="0"
                              value={p.cantidad_pedir}
                              onChange={e => actualizarCantidad(i, e.target.value)}
                              placeholder="0"
                            />
                          </div>
                          <span style={{ width: 80, textAlign: 'right', color: '#aaa', fontSize: 12 }}>${p.costo.toFixed(2)}</span>
                          <span style={{ width: 110, textAlign: 'right', color: cant > 0 ? '#4cc9f0' : '#333', fontWeight: cant > 0 ? 'bold' : 'normal', fontSize: 13 }}>
                            {cant > 0 ? `$${valorRep.toFixed(2)}` : '—'}
                          </span>
                        </div>
                      );
                    })}
                  </div>

                  {itemsConCantidad.length > 0 && (
                    <div style={s.totalRow}>
                      <span style={{ color: '#aaa', fontSize: 13 }}>Total orden ({itemsConCantidad.length} productos):</span>
                      <span style={{ color: '#4cc9f0', fontWeight: 'bold', fontSize: 18, marginLeft: 12 }}>${totalOrden.toFixed(2)}</span>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Modal detalle producto */}
      {modalAbierto && (
        <div style={s.modalOverlay} onClick={cerrarModal}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}>
              <span style={s.modalTitulo}>{productoDetalle?.ultima_compra?.producto || 'Detalle del producto'}</span>
              <button style={s.modalCerrar} onClick={cerrarModal}>✕</button>
            </div>
            {cargandoDetalle ? (
              <p style={{...s.cargando, padding: 60}}>Cargando detalle...</p>
            ) : productoDetalle?.error ? (
              <p style={{ color: '#e63946', padding: 28 }}>{productoDetalle.error}</p>
            ) : productoDetalle ? (
              <>
                <div style={s.filaCompra}>
                  <div style={s.filaCompraInner}>
                    <div style={s.compraGrid}>
                      {[
                        ['Fecha', productoDetalle.ultima_compra.fecha],
                        ['Proveedor', productoDetalle.ultima_compra.proveedor],
                        ['RUC', productoDetalle.ultima_compra.ruc_proveedor],
                        ['Factura', productoDetalle.ultima_compra.factura],
                        ['Forma de pago', productoDetalle.ultima_compra.forma_pago],
                        ['Cantidad comprada', `${productoDetalle.ultima_compra.cantidad_comprada.toFixed(0)} ${productoDetalle.ultima_compra.unidad}`],
                        ['Costo unitario', `$${productoDetalle.ultima_compra.costo.toFixed(2)}`],
                        ['IVA', `${productoDetalle.ultima_compra.iva_pct}%`],
                        ['PVP', `$${productoDetalle.ultima_compra.pvp.toFixed(2)}`],
                      ].map(([label, valor]) => (
                        <div key={label} style={s.compraItem}>
                          <span style={s.compraLabel}>{label}</span>
                          <span style={{...s.compraValor, ...(label === 'PVP' ? {color: '#4cc9f0', fontWeight: 'bold'} : {})}}>{valor}</span>
                        </div>
                      ))}
                    </div>
                    <div style={s.stockWrap}>
                      <div style={s.seccionTitulo}>📦 STOCK</div>
                      <div style={s.stockRow}>
                        <div style={s.stockCard}>
                          <div style={s.stockNum}>{productoDetalle.ultima_compra.stock_anterior.toFixed(0)}</div>
                          <div style={s.stockLabel}>Antes de compra</div>
                        </div>
                        <div style={s.stockArrow}>→</div>
                        <div style={{...s.stockCard, borderColor: '#4cc9f0'}}>
                          <div style={{...s.stockNum, color: '#4cc9f0'}}>{productoDetalle.ultima_compra.stock_actual.toFixed(0)}</div>
                          <div style={s.stockLabel}>Stock actual</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={s.filaVentas}>
                  <div style={s.ventasTopBar}>
                    <span style={s.seccionTitulo}>📊 VENTAS DESDE ÚLTIMA COMPRA</span>
                    <div style={s.ventasResumen}>
                      <span style={s.ventasBadge}>{productoDetalle.total_vendido.toFixed(0)} unidades</span>
                      <span style={{...s.ventasBadge, background: '#1a3a2a', color: '#4caf50'}}>${productoDetalle.total_revenue.toFixed(2)} revenue</span>
                    </div>
                  </div>
                  {productoDetalle.ventas.length === 0 ? (
                    <p style={{ color: '#555', fontSize: 13, padding: '16px 0' }}>Sin ventas desde la última compra</p>
                  ) : (
                    <div style={s.ventasTabla}>
                      <div style={s.ventasHeader}>
                        <span style={{ flex: 2 }}>Fecha</span>
                        <span style={{ flex: 4 }}>Cliente</span>
                        <span style={{ flex: 2 }}>Factura</span>
                        <span style={{ width: 60, textAlign: 'right' }}>Cant.</span>
                        <span style={{ width: 80, textAlign: 'right' }}>Precio</span>
                      </div>
                      <div style={s.ventasScroll}>
                        {productoDetalle.ventas.map((v, i) => (
                          <div key={i} style={{...s.ventasRow, background: i % 2 === 0 ? '#1a1a2e' : '#1e1e2e'}}>
                            <span style={{ flex: 2, color: '#aaa', fontSize: 12 }}>{v.fecha}</span>
                            <span style={{ flex: 4, color: '#fff', fontSize: 13 }}>{v.cliente}</span>
                            <span style={{ flex: 2, color: '#555', fontSize: 12 }}>{v.factura}</span>
                            <span style={{ width: 60, textAlign: 'right', color: '#fff', fontWeight: 'bold', fontSize: 13 }}>{v.cantidad.toFixed(0)}</span>
                            <span style={{ width: 80, textAlign: 'right', color: '#4cc9f0', fontSize: 13 }}>${v.precio.toFixed(2)}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  cargando: { color: '#aaa', textAlign: 'center' },
  headerRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 },
  botonVer: { background: 'none', border: '1px solid #4cc9f0', borderRadius: 6, color: '#4cc9f0', padding: '4px 12px', cursor: 'pointer', fontSize: 12 },
  titulo: { color: '#fff', marginBottom: 4 },
  subtitulo: { color: '#555', fontSize: 13 },
  botonRefresh: { background: 'none', border: '1px solid #444', borderRadius: 8, color: '#aaa', padding: '8px 16px', cursor: 'pointer', fontSize: 13 },
  kpisRow: { display: 'flex', gap: 12, marginBottom: 24, flexWrap: 'wrap' },
  kpiCard: { background: '#1e1e2e', borderRadius: 12, padding: 16, flex: 1, minWidth: 120, borderTop: '3px solid #7209b7' },
  kpiValor: { color: '#fff', fontSize: 26, fontWeight: 'bold', marginBottom: 4 },
  kpiLabel: { color: '#aaa', fontSize: 11 },
  tabs: { display: 'flex', gap: 4, borderBottom: '1px solid #2d2d44', marginBottom: 0 },
  tab: { background: 'none', border: 'none', borderBottom: '2px solid transparent', color: '#888', padding: '12px 20px', cursor: 'pointer', fontSize: 13, display: 'flex', alignItems: 'center', gap: 8 },
  tabActivo: { color: '#fff', fontWeight: 'bold', borderBottomColor: '#e63946' },
  tabBadge: { background: '#e63946', color: '#fff', borderRadius: 10, padding: '2px 7px', fontSize: 11 },
  contenido: { background: '#1e1e2e', borderRadius: '0 0 12px 12px', padding: 24, minHeight: 300 },
  sinAlertas: { textAlign: 'center', padding: '60px 0' },
  tabla: { borderRadius: 8, overflow: 'hidden' },
  tablaHeader: { display: 'flex', padding: '10px 16px', background: '#0f0f1a', color: '#555', fontSize: 11, fontWeight: 'bold', gap: 8 },
  tablaRow: { display: 'flex', padding: '10px 16px', gap: 8, alignItems: 'center', transition: 'background 0.15s' },
  totalRow: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '16px 16px 0', borderTop: '1px solid #2d2d44', marginTop: 8 },
  muertoInfo: { marginBottom: 12 },
  buscadorRow: { display: 'flex', gap: 8, marginBottom: 16 },
  inputBusqueda: { flex: 1, background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 8, color: '#fff', padding: '10px 14px', fontSize: 13 },
  botonBuscar: { background: '#1a2a3e', border: '1px solid #4cc9f0', borderRadius: 8, color: '#4cc9f0', padding: '10px 18px', cursor: 'pointer', fontWeight: 'bold', fontSize: 13 },
  botonLimpiar: { background: '#2d2d44', border: 'none', borderRadius: 8, color: '#aaa', padding: '10px 14px', cursor: 'pointer', fontSize: 13 },
  // Manual
  manualContainer: { display: 'flex', gap: 0, margin: '-24px', minHeight: 500 },
  manualSidebar: { width: 200, background: '#0f0f1a', borderRight: '1px solid #2d2d44', padding: 16, display: 'flex', flexDirection: 'column' },
  sidebarTitulo: { color: '#fff', fontWeight: 'bold', fontSize: 13, marginBottom: 10 },
  searchMarca: { background: '#1a1a2e', border: '1px solid #2d2d44', borderRadius: 6, color: '#fff', padding: '7px 10px', fontSize: 12, marginBottom: 8, width: '100%', boxSizing: 'border-box' },
  marcasList: { flex: 1, overflowY: 'auto', maxHeight: 'calc(100vh - 220px)' },
  marcaItem: { padding: '7px 10px', borderRadius: 6, cursor: 'pointer', color: '#888', fontSize: 12 },
  marcaItemActivo: { background: '#2d2d44', color: '#fff' },
  manualMain: { flex: 1, padding: 24, overflowY: 'auto' },
  manualHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 8 },
  botonImprimir: { background: 'none', border: '1px solid #aaa', borderRadius: 8, color: '#aaa', padding: '8px 14px', cursor: 'pointer', fontSize: 13 },
  botonGuardar: { background: '#e63946', border: 'none', borderRadius: 8, color: '#fff', padding: '8px 16px', cursor: 'pointer', fontWeight: 'bold', fontSize: 13 },
  inputCantidad: { width: 75, background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 6, color: '#fff', padding: '5px 8px', fontSize: 14, textAlign: 'center' },
  // Modal
  modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.75)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 },
  modal: { background: '#1a1a2e', borderRadius: 16, border: '1px solid #2d2d44', width: '90%', maxWidth: 800, maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '18px 28px', borderBottom: '1px solid #2d2d44', flexShrink: 0 },
  modalTitulo: { color: '#fff', fontSize: 15, fontWeight: 'bold', flex: 1, marginRight: 16 },
  modalCerrar: { background: 'none', border: '1px solid #444', borderRadius: 8, color: '#aaa', fontSize: 16, cursor: 'pointer', padding: '6px 12px' },
  filaCompra: { borderBottom: '1px solid #2d2d44', padding: '20px 28px', flexShrink: 0 },
  filaCompraInner: { display: 'flex', gap: 32, alignItems: 'flex-start' },
  compraGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '6px 24px', flex: 1 },
  compraItem: { display: 'flex', flexDirection: 'column', gap: 2 },
  compraLabel: { color: '#555', fontSize: 11 },
  compraValor: { color: '#fff', fontSize: 13 },
  stockWrap: { minWidth: 200 },
  seccionTitulo: { color: '#4cc9f0', fontSize: 11, fontWeight: 'bold', letterSpacing: 1, marginBottom: 12 },
  stockRow: { display: 'flex', alignItems: 'center', gap: 12 },
  stockCard: { flex: 1, background: '#0f0f1a', borderRadius: 8, padding: '12px 8px', textAlign: 'center', border: '1px solid #2d2d44' },
  stockNum: { color: '#fff', fontSize: 24, fontWeight: 'bold' },
  stockLabel: { color: '#555', fontSize: 10, marginTop: 4 },
  stockArrow: { color: '#555', fontSize: 18 },
  filaVentas: { flex: 1, display: 'flex', flexDirection: 'column', padding: '20px 28px', overflow: 'hidden' },
  ventasTopBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8, flexShrink: 0 },
  ventasResumen: { display: 'flex', gap: 8 },
  ventasBadge: { background: '#1a2a3e', color: '#4cc9f0', borderRadius: 6, padding: '4px 12px', fontSize: 12, fontWeight: 'bold' },
  ventasTabla: { flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', borderRadius: 8 },
  ventasHeader: { display: 'flex', padding: '8px 14px', background: '#0f0f1a', color: '#555', fontSize: 11, fontWeight: 'bold', gap: 8, flexShrink: 0 },
  ventasScroll: { overflowY: 'auto', flex: 1 },
  ventasRow: { display: 'flex', padding: '9px 14px', gap: 8, alignItems: 'center' },
};
